import { createTheme } from "@mui/material/styles";
import { amber, green } from "@mui/material/colors";
/*
 * Colors based on branding guidelines:
 *   https://innovasea.sharepoint.com/sites/InnovaseaHub/Branding%20Standards/Forms/AllItems.aspx?id=%2Fsites%2FInnovaseaHub%2FBranding%20Standards%2FBrand%20Assets%2FBrand%20Guidelines%2FInnovasea%20brand%20guidelines%20April%202021%2Epdf&viewid=73794b65%2Dc149%2D4d97%2D9235%2Db158f9a0fa99&parent=%2Fsites%2FInnovaseaHub%2FBranding%20Standards%2FBrand%20Assets%2FBrand%20Guidelines
 */
const customTheme = createTheme({
  palette: {
    primary: { main: "rgb(4, 60, 74)" },
    secondary: { main: "rgb(139, 212, 223)" },
    error: { main: "rgb(228, 77, 38)" }, // JAB: there is no "tertiary" color so use this ... it kinda fits
    success: { main: green[600] },
    warning: { main: amber[700] },
    common: {
      white: "rgba(255,255,255,0.95)",
      black: "rgba(0,0,0,0.9)",
      //@TODO: add these colors (which are currently not used, but should be) when migrating to MUI v7)
      // PRIMARY COLOR PALETTE:
      // darkBlue: "rgb(4, 60, 74)", // (same as primary.main)
      // lightBlue: "rgb(139, 212, 223)", // (same as secondary.main)
      // teal: "rgb(78, 175, 174)",
      // green: "rgb(191, 227, 214)",

      // SECONDARY COLOR PALETTE:
      // coral: "rgb(246,145,126)",
      // yellow: "rgb(244,237,121)",
      // darkGrey: "rgb(82,84,91)",
      // lightGrey: "rgb(216,220,227)",
    },
    background: {
      default: "rgba(255,255,255,0.9)",
    },
  },
  typography: {
    fontFamily: "'Nunito Sans', Arial, sans-serif",
  },
  //
  // OVERRIDES:
  //
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#666",
          boxShadow: "0px 0px 5px -3px black, 5px 5px 15px -5px black",
          fontSize: "0.8rem",
          fontWeight: 300,
          textShadow: "0.5px 0.5px 0.5px #444",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: "whitesmoke",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        // The hover effect for text buttons is too subtle; enhance it globally here
        text: {
          border: "1px solid transparent",
          "&:hover": {
            border: "1px solid rgba(4, 60, 74, 0.3)",
          },
        },
        outlinedSizeSmall: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          border: "1px solid transparent",
          "&:hover:not(.MuiRadio-root):not(.MuiCheckbox-root):not(.MuiSwitch-switchBase)": {
            border: "1px solid rgba(4, 60, 74, 0.3)",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          lineHeight: "0.8em",
          paddingBottom: 8,
          "&.MuiInputLabel-filled.MuiInputLabel-shrink": {
            top: -16,
          },
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          alignContent: "center",
          "& .MuiFormControlLabel-label": {
            fontSize: 13,
          },
          "& .MuiRadio-root": {
            marginTop: -1,
            padding: 2,
          },
          "& .MuiSelect-select": {
            paddingBottom: 4,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          paddingTop: 8,
          paddingBottom: 4,
        },
        root: {
          backgroundColor: "unset",
          "& .MuiSelect-filled": {
            paddingBottom: 4,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          paddingTop: "unset",
          backgroundColor: "unset",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12,
        },
      },
    },
  },
});

export default customTheme;
